import React from "react";
import DropdownTreeSelect from "react-dropdown-tree-select";
import { useTranslation } from "react-i18next";

export class ReactDropdownTreeSelectContainer extends React.Component {
  static getDerivedStateFromProps(props) {
    return {
      data: props.data
    };
  }

  shouldComponentUpdate() {
    return this.props.data !== this.state.data;
  }

  render() {
    return <DropdownTreeSelect {...this.props} {...this.state} />;
  }
}

export const ReactDropdownTreeSelectMemoized = React.memo((props) => {
  const { t } = useTranslation();
  return (
    <DropdownTreeSelect {...props} texts={{placeholder: t("Choose...")}} keepOpenOnSelect={true}/>
  );
});
